module.exports = __webpack_public_path__ + "static/Tonic.ai-3ee641242b4ad72120a5bccad1b157fa.jpg";